import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

// eslint-disable-next-line import/no-cycle
import RowTree from '@components/CustomTree/RowTree'

import './style.scss'

class CustomTree extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { value, sectionsLocked, validateSectionsLocked, parentItems, sectionsCollapse, onSectionsCollapse } = this.props;

    return (
      <ul className='p-tree-container-customer'>
        { value.map(item => (
          <RowTree
            key={item.key}
            data={item}
            sectionsLocked={sectionsLocked}
            validateSectionsLocked={validateSectionsLocked}
            parentItems={parentItems || ''}
            sectionsCollapse={sectionsCollapse}
            onSectionsCollapse={onSectionsCollapse}
          />
        ))
        }
      </ul>
    )
  }
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = {
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(CustomTree);
